import { useEffect, useRef, createRef, forwardRef } from 'react'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'
import classes from './ArticleMain.module.scss'
import ArticleNav from '@/components/Article/ArticleNav'
import StandardContent from '../ArticleContent/StandardContent'
import RecipeContent from '../ArticleContent/RecipeContent'
import {
  dataLayerViewRecipe,
  dataLayerViewProductList,
} from '@/utils/dataLayer'

const ArticleSidebar = dynamic(() => import('../ArticleSidebar'), {
  ssr: false
})

const ArticleMain = forwardRef(
  (
    {
      contentType,
      fields,
      datePublished,
      products,
      showNav = false,
      showSidebar = false,
      blogGlobalSettings,
    },
    ref,
  ) => {
    const h1blocks = fields.content?.filter((item) => item.style === 'h1')
    const router = useRouter()

    useEffect(() => {
      if (contentType === 'recipe') {
        dataLayerViewRecipe({
          recipe: fields.seo,
          products: products,
          related_content: fields.sidebar,
        })
        if (products) {
          dataLayerViewProductList({
            products: products,
            url: router.asPath,
          })
        }
      }
    }, [router.isReady])

    const refs = useRef(
      h1blocks?.reduce((carry, block) => {
        return {
          ...carry,
          [block.children[0].text]: createRef(),
        }
      }, {}),
    )

    const { sidebar } = fields

    const getContent = (type) => {
      switch (type) {
        case 'recipe':
          return (
            <RecipeContent ref={refs} fields={fields} products={products} />
          )
        case 'standard':
          return (
            <StandardContent ref={refs} fields={fields} products={products} />
          )
        default:
          return ''
      }
    }

    return (
      <div ref={ref} className={classes['article-main']}>
        {showNav && refs.current && !!Object.keys(refs.current).length && (
          <ArticleNav ref={refs} />
        )}
        <div className={classes['article-main__wrapper']}>
          {getContent(contentType)}
          {(sidebar || showSidebar) && (
            <ArticleSidebar
              datePublished={datePublished}
              fields={sidebar}
              blogGlobalSettings={blogGlobalSettings}
            />
          )}
        </div>
      </div>
    )
  },
)

export default ArticleMain
